/*  src/data/awardsData.js
    — GENERADO a partir de “2 INFO PARA LINEA DE TIEMPO.docx”
    — Las imágenes deben existir en /public/assets/images/PressAwards
*/

/* ---------- Encabezados de año ---------- */
export const yearHighlights = {
    '2014': 'MTVD Design Studio is born',
    '2015': 'Our work begin to expand',
    '2016': 'We take our designs beyond borders for the first time',
    '2017': 'Creators of Brands',
    '2018': 'Bigger Studio, Bigger Projects',
    '2019': 'We open our studio in Madrid',
    '2020': 'Designing in Times of Covid',
    '2021': 'We open our studio in Buenos Aires – now we have three!',
    '2022': '2 in 1: Specialized teams in Commercial Interior Design and Architecture within the same studio',
    '2023': 'We open our Miami base',
    '2024': 'Celebrating 10 years of design',
    '2025': 'Time for a branding refresh'
  };
  /* ---------- Encabezados de año ---------- */
export const yearHighlightsES = {
    '2014': 'Nace MTVD',
    '2015': 'Nuestro trabajo comienza a expandirse',
    '2016': 'Diseñamos más allá de nuestras fronteras',
    '2017': 'Creadores de marcas',
    '2018': 'Estudio más grande, proyectos más grandes.',
    '2019': 'Abrimos nuestra sede en Madrid',
    '2020': 'Diseñando en tiempos de Covid',
    '2021': 'Nuevo estudio en Buenos Aires',
    '2022': '2 in 1: especialistas en diseño de interiores y arquitectur',
    '2023': 'Abrimos nuestra sede en Miami',
    '2024': ' Celebramos 10 años de Diseño',
    '2025': 'Hora de una renovación de marca.'
  };
  
  /* ---------- Hitos con {label,url} ---------- */
  export const milestones = [
    /* 2014 ----------------------------------------------------- */
    {
      id: 1,
      year: '2014',
      title: 'Kantine',
      image: '/assets/images/PressAwards/1- Kantine.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/kantine-barrio-jardin-un-homenaje-a-la-tradicional-cantina-de-club/' },
        { label: 'Clarín', url: 'https://www.clarin.com/arq/arquitectura/Kantine-Pablo-Dellatorre-Estudio-Montevideo_0_rJNWBIqvXx.html' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/759752/kantine-estudio-montevideo' }
      ]
    },
  
    /* 2015 ----------------------------------------------------- */
    {
      id: 2,
      year: '2015',
      title: 'Casa La Serena',
      image: '/assets/images/PressAwards/2- Casa La Serena.jpg',
      links: [
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/916352/casa-la-serena-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' },
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/la-serena-una-casa-relajada-compacta-y-dinamica/' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/916352/casa-la-serena-estudio-montevideo-plus-pablo-dellatorre' },
        { label: 'Homify', url: 'https://www.homify.com.ar/proyectos/144586/casa-la-serena' },
        { label: 'Estudio Quagliata', url: 'https://arquitectura.estudioquagliata.com/socializarq/casa-la-serena-estudio-montevideo-pablo-dellatorre' },
        { label: 'Houzz', url: 'https://www.houzz.es/fotos/casa-la-serena-phvw-vp~151661564' }
      ]
    },
    {
      id: 3,
      year: '2015',
      title: 'Medialunas Calentitas',
      image: '/assets/images/PressAwards/3- Medialunas Calentitas.jpg',
      links: [
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/772195/panaderia-nil-cafeteria-pablo-dellatorre-plus-estudio-montevideo?ad_medium=office_landing&ad_name=article' },
        { label: 'Clarín', url: 'https://www.clarin.com/diseno/medialunas-calentitas-montevideo-cordoba_0_S1ReBQKvXl.html' },
        { label: 'ArquiTour', url: 'http://www.arquitour.com/mlcalentitas-pablo-dellatorre-estudio-montevideo/2015/10/' },
        { label: 'ArchDaily', url: 'https://www.archdaily.mx/mx/772195/panaderia-nil-cafeteria-pablo-dellatorre-plus-estudio-montevideo' }
      ]
    },
  
    /* 2016 ----------------------------------------------------- */
    {
      id: 4,
      year: '2016',
      title: 'Edward',
      image: '/assets/images/PressAwards/4- Edward.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/banfield-una-pizzeria-con-espiritu-ferroviario-que-remonta-los-inicios/' },
        { label: 'Wideonline', url: 'https://wideonline.com.ar/arquitectura/edward-estudio-montevideo-y-arq-pablo-dellatorre/' },
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/?obra=edward-pizzeria' }
      ]
    },
    {
      id: 5,
      year: '2016',
      title: 'El Mercadillo',
      image: '/assets/images/PressAwards/5- El Mercadillo.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/conoce-el-renovado-mercadillo-de-nueva-cordoba/' }
      ]
    },
    {
      id: 6,
      year: '2016',
      title: 'Milá (Chile)',
      image: '/assets/images/PressAwards/6- Mila.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/un-bodegon-porteno-sorprendente-que-invita-a-navegar-en-el-pasado/' },
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/?obra=bodegon-navegar-pasado' }
      ]
    },
    {
      id: 7,
      year: '2016',
      title: 'Beer Joint',
      image: '/assets/images/PressAwards/7- Beer Joint.jpg',
      links: [
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/868950/beer-joint-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/868950/beer-joint-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' }
      ]
    },
    {
      id: 8,
      year: '2016',
      title: 'Aquiles Café',
      image: '/assets/images/PressAwards/8- Aquiles Cafe.jpg',
      links: [
        { label: 'Archilovers', url: 'https://www.archilovers.com/projects/190803/aquiles-cafe.html' },
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/?obra=aquiles-cafe-lugar-relajarse' },
        { label: 'Ambientes Digital', url: 'https://ambientesdigital.com/aquiles-cafe-estudio-montevideo/' },
        { label: 'Wallpaper*', url: 'https://www.wallpaper.com/tag/cordoba' }
      ]
    },
    {
      id: 9,
      year: '2016',
      title: 'Socios Villa Ballester',
      image: '/assets/images/PressAwards/9- Socios Villa Ballester.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/socios-una-pizzeria-un-bar-y-un-resto-que-buscan-el-mismo-espiritu/' }
      ]
    },
  
    /* 2017 ----------------------------------------------------- */
    {
      id: 10,
      year: '2017',
      title: 'Capó',
      image: '/assets/images/PressAwards/10- Capó.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/capo-un-bar-reo-con-espiritu-propio/' }
      ]
    },
    {
      id: 11,
      year: '2017',
      title: 'Distrito F',
      image: '/assets/images/PressAwards/11- Distrito F.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/distrito-f-un-proyecto-con-aire-urbano-industrial/' }
      ]
    },
    {
      id: 12,
      year: '2017',
      title: 'Galería Monte Tejeda',
      image: '/assets/images/PressAwards/12- Galeria Monte Tejeda.jpg',
      links: [
        { label: 'Metalocus', url: 'https://www.metalocus.es/es/noticias/la-nueva-galeria-monte-tejeda-por-estudio-montevideo-pablo-dellatorre' },
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/?obra=monte-tejeda' }
      ]
    },
    {
      id: 13,
      year: '2017',
      title: 'Manjatu',
      image: '/assets/images/PressAwards/13- Manjatu.jpg',
      links: [
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/774171/majantu-pablo-dellatorre-estudio-montevideo?ad_medium=widget&ad_name=more-from-office-article-show' },
        { label: 'Wallpaper*', url: 'https://www.wallpaper.com/travel/argentina/cordoba/shops/manjatu' },
        { label: 'Divisare', url: 'https://divisare.com/projects/303188-pablo-dellatorre-estudio-montevideo-gonzalo-viramonte-manjatu' }
      ]
    },
    {
      id: 14,
      year: '2017',
      title: 'Galería Gremio',
      image: '/assets/images/PressAwards/14- Galeria Gremio.jpg',
      links: [
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/musa/emergentes/abre-la-primera-galeria-estilo-guemes-en-barrio-jardin/' }
      ]
    },
  
    /* 2018 ----------------------------------------------------- */
    {
      id: 15,
      year: '2018',
      title: 'B Art. Casa Portal',
      image: '/assets/images/PressAwards/15- B Art. Casa Portal.jpg',
      links: [
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/tendencias/esta-es-la-lista-de-los-espacios-reconocidos-en-casa-portal/' },
        { label: 'Wideonline', url: 'https://wideonline.com.ar/empresa/casa-portal-del-hospital-de-ninos/casa-portal-2018/bar-la-resistance-arq-pablo-dellatorre-y-estudio-montevideo/' }
      ]
    },
    {
      id: 16,
      year: '2018',
      title: 'Oficinas Becken',
      image: '/assets/images/PressAwards/16- Oficinas Becken.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/oficinas-costanera-un-edificio-inspirado-en-las-fabricas-de-antano/' }
      ]
    },
    {
      id: 17,
      year: '2018',
      title: 'Oh My Bowl',
      image: '/assets/images/PressAwards/17- Oh My Bowl.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/oh-my-bowl-siamo-dos-espacios-proyectados-para-disfrutar/' }
      ]
    },
    {
      id: 18,
      year: '2018',
      title: 'La Maquinita',
      image: '/assets/images/PressAwards/18- La Maquinita.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/ambientes-hiperconectados-en-un-espacio-de-co-working-muy-particular/' },
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/902064/la-maquinita-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' }
      ]
    },
    {
      id: 19,
      year: '2018',
      title: 'La Sifonda',
      image: '/assets/images/PressAwards/19- La Sifonda.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/la-sifonda-del-paseo-rivera-un-restaurante-con-adn-casero/' }
      ]
    },
    {
      id: 20,
      year: '2018',
      title: 'Cervecería Patagonia',
      image: '/assets/images/PressAwards/20- Cervecería Patagonia.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/la-nueva-cerveceria-patagonia-en-el-teatro-luxor-de-carlos-paz/' }
      ]
    },
    {
      id: 21,
      year: '2018',
      title: 'Siamo',
      image: '/assets/images/PressAwards/21- Siamo.jpg',
      links: [
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/904207/restaurante-siamo-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/904207/restaurante-siamo-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' }
      ]
    },
    {
      id: 22,
      year: '2018',
      title: 'Quade',
      image: '/assets/images/PressAwards/22- Quade.jpg',
      links: [
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/874697/libreria-quede-pablo-dellatorre-plus-estudio-montevideo?ad_medium=office_landing&ad_name=article' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/874697/libreria-quede-pablo-dellatorre-plus-estudio-montevideo?ad_medium=office_landing&ad_name=article' }
      ]
    },
  
    /* 2019 ----------------------------------------------------- */
    {
      id: 23,
      year: '2019',
      title: 'Galería Convento',
      image: '/assets/images/PressAwards/23- Convento.jpg',
      links: [
        { label: 'Prix Versailles', url: 'https://www.prix-versailles.com/es/2019' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/923596/tiendas-restaurantes-hoteles-y-centros-comerciales-de-america-central-el-sur-y-el-caribe-ganadores-continentales-del-prix-versailles-2019' },
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/tendencias/estudio-montevideo-gano-prix-versailles/' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/y-ademas/estudio-montevideo-se-llevo-el-premio-prix-de-versailles-en-galerias-comerciales-caso-convento' },
        { label: 'Arquitectura Propiedades', url: 'https://arquitecturapropiedades.com/2020/11/06/como-transformar-un-convento-en-un-centro-comercial-preservando-el-patrimonio-historico/' },
        { label: 'ARQXP', url: 'https://arqxp.com/prix-versailles-2019-anuncia-vencedores-de-fases-locais/' },
        { label: 'Plataforma Arquitectura', url: 'https://www.plataformaarquitectura.cl/cl/896742/galeria-convento-estudio-montevideo-plus-pablo-dellatorre' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/896742/galeria-convento-estudio-montevideo-plus-pablo-dellatorre?ad_medium=office_landing&ad_name=article' }
      ]
    },
    {
      id: 24,
      year: '2019',
      title: 'Arq Festival',
      image: '/assets/images/PressAwards/24- Arq Festival.jpg',
      links: [
        { label: 'PDF Evento', url: 'https://arqfestival.com/wp-content/uploads/2019/07/Folleto-ARQfestival-2019.pdf' }
      ]
    },
    {
      id: 25,
      year: '2019',
      title: 'Hello Wood Argentina',
      image: '/assets/images/PressAwards/25- Hellowood.jpg',
      links: [
        { label: 'Wideprint', url: 'https://wideprint.com.ar/diseno/egg-o-estudio-montevideo-hello-wood-argentina-2019/' },
        { label: 'TacaDi', url: 'https://tacadi.com/Hello-Wood-2019' },
        { label: 'Madera21', url: 'https://www.madera21.cl/blog/2019/04/18/hello-wood-argentina/' },
        { label: 'Río Negro', url: 'https://www.rionegro.com.ar/solo-madera-para-crear-construir-y-aprender-940365/' },
        { label: 'ParaTi/Infobae', url: 'https://www.infobae.com/parati/deco/202/03/22/mira-como-lucen-de-noche-las-impactantes-estructuras-de-madera-de-la-ultima-hello-wood-argentina/' }
      ]
    },
    {
      id: 26,
      year: '2019',
      title: 'Homes & Co',
      image: '/assets/images/PressAwards/26- Homes and Co.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/homes-co-un-duplex-que-demuestra-sobriedad-y-orden/' }
      ]
    },
    {
      id: 27,
      year: '2019',
      title: 'Quade',
      image: '/assets/images/PressAwards/27- Quade Inauguracion.jpg',
      links: [
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/espacio-de-marca/gabriela-jagodnik-arquitecta-con-alma-inspiradora/' }
      ]
    },
    {
      id: 28,
      year: '2019',
      title: 'Casa Molvento',
      image: '/assets/images/PressAwards/28- Casa Molvento.jpg',
      links: [
        { label: 'Clarín', url: 'https://www.clarin.com/arq/arquitectura/vivienda-inspirada-pueblos-mediterraneos_0_Va7L_GarX.html' },
        { label: 'Arqa', url: 'https://arqa.com/arquitectura/casa-molvento.html' },
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/houses/molvento-house-in-cordoba-argentina-by-estudio-montevideo-pablo-dellatorre' }
      ]
    },
    {
      id: 29,
      year: '2019',
      title: 'Tokin – Muy Güemes',
      image: '/assets/images/PressAwards/29- Tokin Guemes.jpg',
      links: [
        { label: 'Arqa', url: 'https://arqa.com/arquitectura/interiorismo/tokin.html' },
        { label: 'Wideprint', url: 'https://wideprint.com.ar/arquitectura/tokin-sushi-bar-estudio-montevideo-2/' },
        { label: '88DesignBox', url: 'http://88designbox.com/architecture/tokin-sushi-bar-by-estudio-montevideo-3826.html' },
        { label: 'World Architecture', url: 'https://worldarchitecture.org/article-links/eezhf/estudio-montevideo-completes-tokin-sushi-bar-in-crdoba-with-potteries-hanged-from-the-room.html' }
      ]
    },
  
    /* 2020 ----------------------------------------------------- */
    {
      id: 30,
      year: '2020',
      title: 'Rest. Velo (Madrid)',
      image: '/assets/images/PressAwards/30- Restaurante Velo.jpg',
      links: [
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/tendencias/restaurante-velo-obra-de-estudio-montevideo-en-madrid/' },
        { label: 'Clarín', url: 'https://www.clarin.com/arq/argentinos-disenan-restaurante-anti-coronavirus-madrid_0_4HpwV9ctP.html' },
        { label: 'AD España', url: 'https://www.revistaad.es/lugares/articulos/diseno-restaurante-postcovid-mamparas-vidrio/26108' },
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/obra/restaurante-velo-unidos-pero-separados/' },
        { label: 'Arquitectura Propiedades', url: 'https://arquitecturapropiedades.com/2020/09/30/restaurante-y-gastronomia-en-pandemia-velo-estudio-montevideo/' }
      ]
    },
    {
      id: 31,
      year: '2020',
      title: 'Casa La Serena',
      image: '/assets/images/PressAwards/31- Casa La Serena.jpg',
      links: [
        { label: 'Clarín', url: 'https://www.clarin.com/arq/recrear-espiritu-bar-vivienda-moderna_0_-wy-QMGb.html' }
      ]
    },
    {
      id: 32,
      year: '2020',
      title: 'Cienfuegos',
      image: '/assets/images/PressAwards/32- Cienfuegos.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/cienfuegos-arquitectura-que-le-da-protagonismo-al-fuego/' },
        { label: 'Archello', url: 'https://archello.com/project/cienfuegos' }
      ]
    },
    {
      id: 33,
      year: '2020',
      title: 'Huelga',
      image: '/assets/images/PressAwards/33- Huelga.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/un-proyecto-gastronomico-inspirado-en-la-rebelion-obrera-de-nueva-york/' }
      ]
    },
    {
      id: 34,
      year: '2020',
      title: 'COC',
      image: '/assets/images/PressAwards/34- COC.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/estudio-montevideo-arquitectos-cordobeses-nominados/' },
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/negocios/equipo-detras-de-locales-mas-atractivos-de-cordoba/' }
      ]
    },
  
    /* 2021 ----------------------------------------------------- */
    {
      id: 35,
      year: '2021',
      title: 'Estudio Montevideo',
      image: '/assets/images/PressAwards/35- Estudio Montevideo.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/asi-es-el-laboratorio-de-ideas-de-estudio-montevideo/' }
      ]
    },
    {
      id: 36,
      year: '2021',
      title: 'Homa',
      image: '/assets/images/PressAwards/36- Homa.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/homa-cuando-la-arquitectura-transforma-una-casa-antigua-en-un-bar-2/' }
      ]
    },
    {
      id: 37,
      year: '2021',
      title: 'Comuna 14',
      image: '/assets/images/PressAwards/37- Comuna 14.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/comuna-14-arquitectura-pensada-para-una-comunidad-sencilla-y-humble/' }
      ]
    },
    {
      id: 38,
      year: '2021',
      title: 'Casa Las Corzuelas',
      image: '/assets/images/PressAwards/38- Casa Las Corzuelas.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/casa-las-corzuelas-un-espacio-pensado-para-disfrutar-con-amigos/' }
      ]
    },
  
    /* 2022 ----------------------------------------------------- */
    {
      id: 39,
      year: '2022',
      title: 'TENDIEZ',
      image: '/assets/images/PressAwards/39- Gabi en Tendiez.jpg',
      links: [
        { label: 'TENDIEZ', url: 'https://tendiez.com.ar/tendiez-experiencias-transformar-la-arquitectura-gastronomica-desde-el-diseno-el-negocio-y-la-experiencia-11-de-octubre-2022/' },
        { label: 'Los Andes', url: 'https://www.losandes.com.ar/arquitectura/el-15-de-diciembre-tendiez-experiencias-con-5-expertos-en-espacios-culturales-y-gastronomicos/' },
        { label: 'YouTube', url: 'https://www.youtube.com/watch?v=II3Oy4mWdfE' }
      ]
    },
    {
      id: 40,
      year: '2022',
      title: 'COC',
      image: '/assets/images/PressAwards/40- Premio Shop!.jpg',
      links: [
        { label: 'VMSD', url: 'https://vmsd.com/36-winners-from-the-2022-shop-design-awards/' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/y-ademas/estudio-montevideo-es-de-oro-en-la-competencia-shop-design-awards-2021-mejor-diseno-de-restaurante' },
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/negocios/en-fotos-arquitectos-cordobeses-obtuvieron-un-premio-por-mejor-diseno-de-cocteleria/' }
      ]
    },
    {
      id: 41,
      year: '2022',
      title: 'Jardín Santo Domingo',
      image: '/assets/images/PressAwards/41- Jardin Santo Domingo.jpg',
      links: [
        { label: 'Arqa', url: 'https://arqa.com/arquitectura/jardin-santo-domingo.html' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/nota-principal/el-nivel-inicial-de-santo-domingo-no-tiene-aulas-inspirado-en-la-educacion-nordica-y-disenado-por-estudio-montevideo' },
        { label: 'Archiscene', url: 'https://www.archiscene.net/education/jardin-santo-domingo-estudio-montevideo/' }
      ]
    },
    {
      id: 42,
      year: '2022',
      title: 'Tokin (Villa Allende)',
      image: '/assets/images/PressAwards/42- Tokin Villa Allende.jpg',
      links: [
        { label: 'Comercio & Justicia', url: 'https://comercioyjusticia.info/negocios/__trashed-4/' },
        { label: 'Punto a Punto', url: 'https://puntoapunto.com.ar/tokin-desembarco-en-villa-allende-y-planea-llegar-a-miami/' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/y-ademas/tokin-desembarca-en-villa-allende-con-lo-mejor-de-la-cocina-nikkei-el-tercer-local-en-cordoba' }
      ]
    },
    {
      id: 43,
      year: '2022',
      title: 'Central Club',
      image: '/assets/images/PressAwards/43- Central Club.jpg',
      links: [
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/obra/central-club/' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/plus/nace-central-club-de-la-mano-de-estudio-montevideo-con-multifunciones-y-canchas-de-world-padel-tour' },
        { label: 'Archiscene', url: 'https://www.archiscene.net/mixed-use/central-club-estudio-montevideo/' }
      ]
    },
  
    /* 2023 ----------------------------------------------------- */
    {
      id: 44,
      year: '2023',
      title: 'Euroshop',
      image: '/assets/images/PressAwards/44- Speakers en Euroshop.png',
      links: [
        { label: 'Evento', url: 'https://events.euroshop.de/en/event/intention-emotion-emotion-intention' },
        { label: 'YouTube', url: 'https://www.youtube.com/watch?v=zVrCMFJ2NCQ' }
      ]
    },
    {
      id: 45,
      year: '2023',
      title: 'UTUCO – Casa FOA',
      image: '/assets/images/PressAwards/45- Utuco CASA FOA.jpg',
      links: [
        { label: 'Casa FOA', url: 'https://casafoa.com/todos-los-premios-casa-foa-cordoba-2023-manantiales-2' },
      /*   { label: 'Casa FOA – Espacio', url: 'https://casafoa.com/espacio-casa-foa/espacio-n16' }, */
        { label: 'InfoNegocios', url: 'https://infonegocios.info/las-marcas-dicen/utuco-en-foa' },
        { label: 'La Nación', url: 'https://www.lanacion.com.ar/preview-arc/VUZDWCTHTBFHFPI3RTZQKBCP4Y?_website=la-nacion-ar&_ignoreCache=true' },
        { label: 'El Doce TV', url: 'https://eldoce.com.ar/comercial/cli/nota_casa_foa_elshow_dia13-04-23.mp4' },
        { label: 'Circuito Gastronómico', url: 'https://www.circuitogastronomico.com/casa-foa-cordoba-2023-como-es-el-espacio-de-estudio-montevideo-y-que-vas-a-poder-comer-ahi-mismo/' },
        { label: 'Drive', url: 'https://drive.google.com/file/d/1GlqWsuATqWsHMrXCIsT1-ICmouFRESfg/view' },
        { label: 'VMSD', url: 'https://vmsd.com/casa-foa-cordoba-argentina/' },
        { label: 'Comercio & Justicia', url: 'https://comercioyjusticia.info/salidas/utuco-dice-presente-en-casa-foa/' },
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/vos/para-visitar-en-casa-foa-una-cafeteria-ambientada-con-el-paisaje-y-los-productos-de-cordoba/' }
      ]
    },
 /*    {
      id: 46,
      year: '2023',
      title: 'Cañuelas Village (Clarín)',
      image: '/assets/images/PressAwards/46- Cañuelas Village.jpg',
      links: []
    }, */
    {
      id: 47,
      year: '2023',
      title: 'Casa El Bosque',
      image: '/assets/images/PressAwards/47- Casa El Bosque.jpg',
      links: [
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/houses/el-bosque-house-cordoba-argentina-by-estudio-montevideo' },
        { label: 'Designboom', url: 'https://www.designboom.com/architecture/estudio-montevideo-el-bosque-casa-gonzalo-viramonte-argentina-07-30-2023/' },
        { label: 'e‑architect', url: 'https://www.e-architect.com/argentina/el-bosque-house-cordoba-argentina' },
        { label: 'ArchDaily', url: 'https://www.archdaily.cl/cl/1004680/casa-el-bosque-estudio-montevideo' },
        { label: 'Reddit', url: 'https://www.reddit.com/r/amazing_architecture/comments/15bb0sr/el_bosque_house_c%C3%B3rdoba_argentina_by_estudio/?rdt=65056' },
        { label: 'StepienyBarno', url: 'https://stepienybarno.es/blog/2023/08/07/casa-el-bosque-proyectodeldia/' },
        { label: 'JustCrea', url: 'https://justcrea.com/proyectos/argentina/cordoba/cordoba-1/arquitectura-residencial/la-casa-el-bosque-de-estudio-montevideo' },
        /* { label: 'Archiexpo', url: 'https://projects.archiexpo.es/project-290000.html' }, */
        { label: 'Espacio y Confort', url: 'https://espacioyconfort.com.ar/contenido/2635/casa-el-bosque' },
        { label: 'AyC Digital', url: 'https://arquitecturayconstrucciondigital.com/news/casa-el-bosque-2/' }
      ]
    },
    {
      id: 48,
      year: '2023',
      title: 'Felicity Pop‑Up',
      image: '/assets/images/PressAwards/48- Felicity Pop Up.jpg',
      links: [
        { label: 'VMSD', url: 'https://vmsd.com/felicity/' }
      ]
    },
    {
      id: 49,
      year: '2023',
      title: 'Barilatte',
      image: '/assets/images/PressAwards/49- Barilatte.jpg',
      links: [
        { label: 'Punto a Punto', url: 'https://puntoapunto.com.ar/la-cadena-de-helados-bariloche-abandona-su-antiguo-nombre-y-ahora-se-lanza-al-mercado-como-barilatte/' }
      ]
    },
    {
      id: 50,
      year: '2023',
      title: 'Cordiez Mixo',
      image: '/assets/images/PressAwards/50- Cordiez Mixo.jpg',
      links: [
        { label: 'InfoNegocios', url: 'https://infonegocios.info/plus/no-solo-bares-y-restaurantes-hace-estudio-montevideo-tambien-el-restyling-de-mixo-by-cordiez' },
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/supermercado-mixo-cordiez-cambio-de-imagen-audaz/' },
        { label: 'Archiscene', url: 'https://www.archiscene.net/commercial/mixo-cordiez-supermarket-estudio-montevideo/' },
        { label: 'Interior Design', url: 'https://interiordesign.net/projects/supermarket-design-estudio-montevideo-cordoba-argentina/' }
      ]
    },
    {
      id: 51,
      year: '2023',
      title: 'Suite House Cariló',
      image: '/assets/images/PressAwards/51- Suite House.jpg',
      links: [
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/residential-building/suite-house-carilo-argentina-by-estudio-montevideo' },
        { label: 'Reddit', url: 'https://www.reddit.com/r/amazing_architecture/comments/15ez9jx/suite_house_carilo_argentina_by_estudio_montevideo/' }
      ]
    },
    {
      id: 52,
      year: '2023',
      title: 'Casa Hotel Nómada',
      image: '/assets/images/PressAwards/52- Casa Hotel Nomada.jpg',
      links: [
        { label: 'Archipiélago', url: 'https://archipielago.estancialapaz.com.ar/casas/' },
        { label: 'La Nación', url: 'https://www.lanacion.com.ar/propiedades/construccion-y-diseno/en-venta-doce-casas-y-doce-estudios-de-arquitectura-en-una-estancia-historica-de-cordoba-que-fue-de-nid20052023/' }
      ]
    },
    {
      id: 53,
      year: '2023',
      title: 'Brevet Cycling Café',
      image: '/assets/images/PressAwards/53- Brevet.jpg',
      links: [
        { label: 'Cugat.cat', url: 'https://www.cugat.cat/noticies/societat/160609/obre-brevet-cycling-cafe_-la-nova-cafeteria-sostenible-per-a-ciclistes' }
      ]
    },
    {
      id: 54,
      year: '2023',
      title: 'Che Mono',
      image: '/assets/images/PressAwards/54- Che Mono.jpg',
      links: [
        { label: 'Clarín – Kiosco', url: 'https://www.kiosco.clarin.com/arq/20230613' },
        { label: 'Clarín', url: 'https://www.clarin.com/arq/edicion-especial-arq-dedicada-bares-restaurantes_0_8dtmCX8sGY.html' },
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/che-mono-un-nuevo-bodegon-porteno-llega-a-banfield/' },
        { label: 'HiContract', url: 'https://www.hicontract.com/proyecto/che-mono/' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/y-ademas/las-10-mejores-fotos-de-che-mono-el-trabajo-de-estudio-montevideo-que-puede-ganar-en-el-restaurant-bar-design-awards-2023' }
      ]
    },
    {
      id: 55,
      year: '2023',
      title: 'Che Mono',
      image: '/assets/images/PressAwards/55- Che Mono Shortlisted.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/estudio-montevideo-restaurant-bar-design-awards/' },
        { label: 'VISI', url: 'https://visi.co.za/restaurant-bar-design-awards-announces-2023-shortlist/' }
      ]
    },
    {
      id: 56,
      year: '2023',
      title: 'Che Mono',
      image: '/assets/images/PressAwards/56- Opal Award.jpg',
      links: []
    },
    {
      id: 57,
      year: '2023',
      title: 'CAMZA',
      image: '/assets/images/PressAwards/57- Gabi en CAMZA.jpg',
      links: [
        { label: 'Clarín – Kiosco', url: 'https://www.kiosco.clarin.com/arq/20231108' },
        { label: 'YouTube', url: 'https://www.youtube.com/watch?v=p9c9WyIZv5o' }
      ]
    },
    {
      id: 58,
      year: '2023',
      title: 'Feyro',
      image: '/assets/images/PressAwards/58- Feyro.jpg',
      links: [
        { label: 'Punto a Punto', url: 'https://puntoapunto.com.ar/con-un-nuevo-concepto-feyro-celebro-su-reapertura-en-villa-allende/' }
      ]
    },
    {
      id: 60,
      year: '2023',
      title: 'Ranking Clarín',
      image: '/assets/images/PressAwards/60- Ranking Clarin.jpg',
      links: [
        { label: 'Clarín – Kiosco', url: 'https://www.kiosco.clarin.com/arq/20231121' }
      ]
    },
    {
      id: 61,
      year: '2023',
      title: 'Soberana',
      image: '/assets/images/PressAwards/61- Soberana Guia Michelin.jpg',
      links: [
        { label: 'Guía Michelin', url: 'https://guide.michelin.com/ar/es/provincia-mendoza/mendoza_777010/restaurante/soberana' },
        { label: 'InfoNegocios', url: 'https://infonegocios.info/plus/diseno-cordobes-detras-de-una-de-las-estrellas-michelin-de-mendoza-como-es-soberana-el-resto-con-el-sello-de-estudio-montevideo' }
      ]
    },
  
    /* 2024 ----------------------------------------------------- */
    {
      id: 62,
      year: '2024',
      title: '11:11 Street Mall',
      image: '/assets/images/PressAwards/62- 11 11.jpg',
      links: [
        { label: 'InfoNegocios', url: 'https://infonegocios.info/nota-principal/el-reloj-marca-las-11-11-para-docta-asi-sera-el-street-mall-que-estara-en-el-corazon-de-la-urbanizacion-de-grupo-proaco' }
      ]
    },
    {
      id: 63,
      year: '2024',
      title: 'Foto estudio',
      image: '/assets/images/PressAwards/63- NY Awards.jpg',
      links: [
        { label: 'InfoNegocios', url: 'https://infonegocios.info/y-ademas/estudio-montevideo-que-bien-te-veo-ganan-premios-en-los-ny-design-awards-y-retail-design-institute' }
      ]
    },
    {
      id: 64,
      year: '2024',
      title: 'Lobby Azur – Casa FOA',
      image: '/assets/images/PressAwards/64- Lobby Azur.jpg',
      links: [
        { label: 'Clarín – Kiosco', url: 'https://www.kiosco.clarin.com/arq/20240514' },
        { label: 'La Voz', url: 'https://www.lavoz.com.ar/diseno/casa-foa-espacio-numero-3-texturas-y-materiales-locales/' },
        { label: 'La Nación', url: 'https://www.lanacion.com.ar/lifestyle/techos-como-nunca-viste-propuestas-bitono-y-deco-japandi-las-tendencias-que-despuntan-en-casa-foa-nid21052024/' },
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/lobby-de-hotel-azur/' },
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/hotel/hotel-azur-lobby-cordoba-argentina-by-estudio-montevideo' },
        { label: 'Iluminet', url: 'https://iluminet.com/visitando-casa-foa-en-cordoba-argentina/' },
        { label: 'Architectural Authority', url: 'https://www.thearchitecturalauthority.com/article/design-excellence-the-hotel-azur-lobby-by-estudio-montevideo' },
        { label: 'Estilo Propio', url: 'https://revistaestilopropio.com/estudio-montevideo-medalla-de-plata-al-sentir/' },
        { label: 'Diario del Hotelero', url: 'https://www.diariodelhotelero.com/nota-estudio-montevideo--medalla-de-plata-al-sentir.-171975' }
      ]
    },
    {
      id: 65,
      year: '2024',
      title: 'Che Mono',
      image: '/assets/images/PressAwards/65- Lobro digital Comer y Beber.jpg',
      links: [
        { label: 'Publuu', url: 'https://publuu.com/flip-book/222650/1424398' }
      ]
    },
    {
      id: 66,
      year: '2024',
      title: 'Barilatte (Chacabuco)',
      image: '/assets/images/PressAwards/66- Barilatte Chacabuco.jpg',
      links: [
        { label: 'DyD', url: 'https://dyd.com.ar/9371-2/' }
      ]
    },
    {
      id: 67,
      year: '2024',
      title: 'La Maquinita',
      image: '/assets/images/PressAwards/67- La Maquinita Quilmes.jpg',
      links: [
        { label: 'Ámbito', url: 'https://www.ambito.com/negocios/la-maquinita-coworking-festeja-la-expansion-su-espacio-vicente-lopez-n6026684' }
      ]
    },
    {
      id: 68,
      year: '2024',
      title: 'Valpo 1',
      image: '/assets/images/PressAwards/68- Valpo 1.jpg',
      links: [
        { label: 'Arqa', url: 'https://arqa.com/arquitectura/valpo-1.html' },
        { label: 'NoticiasArquitectura', url: 'https://noticiasarquitectura.info/argentina-valpo-1-estudio-montevideo/' },
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/houses/valpo-1-cordoba-argentina-by-estudio-montevideo' },
        { label: 'Architectural Authority', url: 'https://www.thearchitecturalauthority.com/article/loft-revolution-valpo-1-by-estudio-montevideo' },
        { label: 'El Arqui MX', url: 'https://elarquimx.com/planos-de-loft-valpo-1-estudio-montevideo/' },
        { label: 'gooood', url: 'https://www.gooood.cn/valpo-housing-complexes-by-montevideo-studio.htm' },
        { label: 'MemarNews', url: 'https://memarnews.com/%D9%86%DA%AF%D8%A7%D9%87%DB%8C-%D8%A8%D9%87-%D9%BE%D8%B1%D9%88%DA%98%D9%87-valpo-%D8%B7%D8%B1%D8%AD%DB%8C-%D8%A7%D8%B2-estudio-montevideo/' }
      ]
    },
    {
      id: 69,
      year: '2024',
      title: 'Valpo 2',
      image: '/assets/images/PressAwards/69- Valpo 2.jpg',
      links: [
        { label: 'Arqa', url: 'https://arqa.com/arquitectura/valpo-2.html' },
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/houses/valpo-2-cordoba-argentina-by-estudio-montevideo' },
        { label: 'Architectural Authority', url: 'https://www.thearchitecturalauthority.com/article/legacy-living-valpo-2-by-estudio-montevideo' }
      ]
    },
    {
      id: 70,
      year: '2024',
      title: 'Oficinas Blend',
      image: '/assets/images/PressAwards/70- Oficinas Blend.jpg',
      links: [
        { label: 'AyC Digital', url: 'https://arquitecturayconstrucciondigital.com/notas/oficinas-blend/' }
      ]
    },
    {
      id: 71,
      year: '2024',
      title: 'Casa El Bosque',
      image: '/assets/images/PressAwards/71- Casa El Bosque.jpg',
      links: [
        { label: 'AyC Digital', url: 'https://arquitecturayconstrucciondigital.com/notas/casa-el-bosque-2/' }
      ]
    },
    {
      id: 72,
      year: '2024',
      title: 'Ranking Clarín',
      image: '/assets/images/PressAwards/72- Ranking Clarin 2024.jpg',
      links: [
        { label: 'Clarín – Kiosco', url: 'https://www.kiosco.clarin.com/arq/20240917' }
      ]
    },
    {
      id: 73,
      year: '2024',
      title: 'Merce',
      image: '/assets/images/PressAwards/73 - Merce.jpg',
      links: [
        { label: 'Revista Deck', url: 'https://www.revistadeck.com/merce-cordoba-argentina/' }
      ]
    },
    {
      id: 74,
      year: '2024',
      title: 'Felicity BA',
      image: '/assets/images/PressAwards/74- Felicity BA.jpg',
      links: [
        { label: 'Amazing Architecture', url: 'https://amazingarchitecture.com/showroom/felicity-buenos-aires-argentina-by-estudio-montevideo' }
      ]
    },
    {
      id: 75,
      year: '2024',
      title: 'Central Club',
      image: '/assets/images/PressAwards/75- Premio Central Club.jpg',
      links: [
        { label: 'NY Design Awards', url: 'https://nyarchitectureawards.com/winner-info.php?id=482' }
      ]
    },
    {
      id: 76,
      year: '2024',
      title: 'Casa El Bosque',
      image: '/assets/images/PressAwards/76- Casa El Bosque.jpg',
      links: [
        { label: 'NY Design Awards', url: 'https://nyarchitectureawards.com/winner-info.php?id=489' }
      ]
    },
    {
      id: 77,
      year: '2024',
      title: 'Charla Riyadh',
      image: '/assets/images/PressAwards/77- Charla Riyadh.jpg',
      links: [
        { label: 'LinkedIn', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7234577375085117440' }
      ]
    },
  
    /* 2025 ----------------------------------------------------- */
    {
      id: 78,
      year: '2025',
      title: 'Soberana',
      image: '/assets/images/PressAwards/78- Soberana ARCHITECTURE MASTERPRIZE.jpg',
      links: [
        { label: 'Architecture MasterPrize', url: 'https://architectureprize.com/winners/winner.php?id=8898&mode=hm&compID=12810' }
      ]
    },
    {
      id: 79,
      year: '2025',
      title: 'Che Mono',
      image: '/assets/images/PressAwards/79- Che Mono Archit.jpg',
      links: [
        { label: 'Architizer', url: 'https://architizer.com/projects/che-mono/' }
      ]
    }
  ];
  